/**
 * 路由定义页面，路由定义有两种方式:
 * 1、import需要的组件，将代码直接打包到主业务逻辑的JS代码包中
 * 2、通过webpack的code split机制对页面组件进行异步按需加载
 * */

"use strict";

import Vue from "vue";
import Router from "vue-router";
import Home from "@src/pages/index";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/sharePage",
      name: "sharePage",
      component: function (resolve) {
        require(['../pages/sharePage/index.vue'], resolve);
      }
    },
    {
      path: "/rulePage",
      name: "rulePage",
      component: function (resolve) {
        require(['../pages/rulePage/index.vue'], resolve);
      }
    },
    {
      path: "/inviteCodePage",
      name: "inviteCodePage",
      component: function (resolve) {
        require(['../pages/inviteCodePage/index.vue'], resolve);
      }
    },
    {
      path: "*",
      redirect: "/"
    },
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js